const FormSelect = ({
    entity,
    fieldName,
    handleInputChange,
    options,
    placeholder,
    label,
    multiple = false,
    multipleFieldName = '',
    mb = 3,
    disabled = false,
    errors
}: {
    entity: any,
    fieldName: string,
    handleInputChange: any,
    options: any[],
    placeholder?: string,
    label?: string,
    multiple?: boolean,
    multipleFieldName?: string,
    mb?: number,
    disabled?: boolean,
    errors?: any
}) => {

    if (multiple && disabled && entity[fieldName].length > 1) {
        const selectedValues = entity[fieldName].filter(e => e[multipleFieldName]).map(e => e[multipleFieldName]);
        return (
            <div>
                <h6>{label ? label : fieldName}</h6>
                <ul className={`list-group ${mb && mb > 0 && `mb-${mb}`}`}>
                    {options.filter(o => selectedValues.includes(o[multipleFieldName])).map(o => (<li className="list-group-item" key={o[multipleFieldName]}>{o.name}</li>))}
                </ul>
            </div>
        );
    }

    return (
        <div className={`form-floating ${mb && mb > 0 && `mb-${mb}`}`}>
            <select
                className="form-select"
                id={fieldName}
                aria-label={label ? label : fieldName}
                value={multiple ? entity[fieldName].filter(e => e[multipleFieldName]).map(e => e[multipleFieldName]) : entity[fieldName]}
                onChange={handleInputChange}
                multiple={multiple ? true : undefined}
                disabled={disabled}>
                {placeholder && <option value={undefined} disabled selected hidden>{placeholder}</option>}
                {
                    options && options.map((option) => (
                        <option key={multiple
                            ? option[multipleFieldName]
                            : option[fieldName]}
                            value={multiple
                                ? option[multipleFieldName]
                                : option[fieldName]}
                        >{option.name}</option>
                    ))
                }
            </select>
            <label htmlFor={fieldName}>{label ? label : fieldName}</label>
            {errors?.[fieldName] &&
                <div className="invalid-feedback">
                    {errors?.[fieldName]}
                </div>}
        </div>
    )
}

export default FormSelect;